var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadBrochure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#00567A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 8C19 7.44772 18.5523 7 18 7C17.4477 7 17 7.44772 17 8L19 8ZM17.2929 26.7071C17.6834 27.0976 18.3166 27.0976 18.7071 26.7071L25.0711 20.3431C25.4616 19.9526 25.4616 19.3195 25.0711 18.9289C24.6805 18.5384 24.0474 18.5384 23.6569 18.9289L18 24.5858L12.3431 18.9289C11.9526 18.5384 11.3195 18.5384 10.9289 18.9289C10.5384 19.3195 10.5384 19.9526 10.9289 20.3431L17.2929 26.7071ZM17 8L17 26L19 26L19 8L17 8Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBrochure);
export default __webpack_public_path__ + "static/media/downloadBrochure.289380a95b23ec2b7710e12eabc7bf9c.svg";
export { ForwardRef as ReactComponent };